import { FaAppleAlt, FaChartLine, FaDumbbell, FaHeadset, FaTrophy, FaUsers, FaWhatsapp } from "react-icons/fa";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function About() {

    const list = [
        { icon: <FaDumbbell />, name: "Personalized Training", desc: "Custom workout plans tailored to your goals." },
        { icon: <FaAppleAlt />, name: "Nutrition Guidance", desc: "Flexible diet plans for sustainable results." },
        { icon: <FaChartLine />, name: "Progress Tracking", desc: "Weekly check-ins and measurable progress." },
        { icon: <FaHeadset />, name: "10am - 7pm", desc: "Always available to guide and motivate you." }
    ]

    const detail = [
        { number: "15+", name: "Years Experience" },
        { number: "500+", name: "Clients Trained" },
        { number: "95%", name: "Success Rate" },
    ]

    return (
        <>
            <title>About The Fitness Expert | Online Fitness Coach & Trainer</title>
            <meta name="description" content="Learn more about The Fitness Expert and our mission to help people achieve their fitness goals through personalized workout plans, nutrition coaching, and online fitness guidance. Meet your dedicated coach and start your transformation journey." />
            <meta name="keywords" content="about The Fitness Expert, fitness coach, online personal trainer, certified fitness coach, fitness expert India, transformation coach, online coaching, nutrition coach, fat loss coach, muscle building coach, fitness journey, personal fitness trainer, health coach" />
            <meta property="og:title" content="About The Fitness Expert | Meet Your Fitness Coach" />
            <meta property="og:site_name" content="The Fitness Expert" />
            <meta property="og:url" content="https://thefitnessexpert.in/user/About" />
            <meta property="og:description" content=" Discover the story behind The Fitness Expert. Learn about our coaching philosophy, experience, and commitment to helping clients transform their lives through fitness and nutrition." />
            <meta property="og:image" content="logo.png"></meta>
            <meta name="twitter:card" content="app" />
            <meta name="twitter:site" content="@thefitnessexpert" />
            <meta name="twitter:description" content="Discover the story behind The Fitness Expert. Learn about our coaching philosophy, experience, and commitment to helping clients transform their lives through fitness and nutrition." />
            <meta name="twitter:app:country" content="India" />
            <Navbar />
            <section className="py-5 bg-light">
                <div className="container">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-5 col-12">
                            <div className="position-relative">
                                <img src="../images/coachh.jpeg" alt="" className="img-fluid w-100 rounded-4 shadow bg-dark" />
                                <div className="coach-quote shadow">
                                    <h3>Fitness Expert</h3>
                                    <p className="mb-0">
                                        Fitness is not just a workout. It's a lifestyle built on
                                        <span className="text-danger fw-bold">
                                            {" "}discipline, consistency
                                        </span>
                                        {" "}and belief.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-7 col-12">
                            <p className="text-danger fw-bold text-uppercase p-0 m-0">About Coach</p>
                            <h1 className="fw-bold h2">About the Coach</h1>
                            <p className="lead text-muted">
                                Helping you transform your body, mind and lifestyle with
                                personalized coaching and proven strategies.
                            </p>
                            <div className="row g-3 my-3">
                                {detail.map((row, index) => (
                                    <div key={index} className="col-lg-4 col-md-4 col-12">
                                        <div className="stat-card text-center">
                                            <FaUsers className="text-danger fs-3 mb-2" />
                                            <h2 className="fw-bold">{row.number}</h2>
                                            <p className="mb-0 text-muted">{row.name}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="row g-3">
                                <div className="cert-card">
                                    🏆Certified Trainer
                                </div>
                            </div>
                            <hr />
                            <h3 className="fw-bold">My Story</h3>
                            <p className="text-muted">
                                My fitness journey started when I was struggling with my own
                                health and confidence. Through consistency, the right guidance,
                                and a disciplined lifestyle, I transformed my body and mind and
                                now help others do the same.
                            </p>
                            <hr />
                            <div className="row">
                                <div className="col-md-6">
                                    <h4 className="fw-bold">My Philosophy</h4>
                                    <p className="text-muted">
                                        Sustainable results through balanced training,
                                        smart nutrition and a positive mindset.
                                    </p>
                                </div>
                                <div className="col-md-6">
                                    <h4 className="fw-bold">My Mission</h4>
                                    <p className="text-muted">
                                        To help you become the strongest version of yourself,
                                        inside and out.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-5 g-4 bg-dark rounded-4 p-4">
                        {list.map((row, index) => (
                            <div className="col-lg-3 col-md-6 col-12" key={index}>
                                <div className="d-flex text-white">
                                    <div className="me-3">
                                        <span className="fs-2 text-danger">{row.icon}</span>
                                    </div>
                                    <div>
                                        <h5 className="fw-bold">{row.name}</h5>
                                        <p className="text-light mb-0">{row.desc}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <div className="position-fixed bottom-0 end-0 p-3 z-3">
                <button className="fixed-join-btn text-light fw-bold px-3 py-2 shadow rounded-pill bgcolor"
                    onClick={() =>
                        window.open("https://wa.me/919876857579?text=Hello%20Harman%20Sir%20👋%0A%0AI%20visited%20your%20website%20and%20I'm%20interested%20in%20your%20fitness%20coaching%20programs.", "_blank"
                        )}>
                    <FaWhatsapp size={24} />
                </button>
            </div >
            <Footer />
        </>
    )
}